module.exports = __webpack_public_path__ + "img/symbol_9.ffe8a7f2.png";